import script from "./legoIconButtonExtend.vue?vue&type=script&lang=js"
export * from "./legoIconButtonExtend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/components/lego/extend/legoIconButtonExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d3e3286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d3e3286', __exports__)) {
    api.reload('7d3e3286', __exports__)
  }
  
}


export default __exports__